import { useEffect, useState } from "react";
import api, { formatErr } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Target, Coins, Diamond, Gift as GiftIcon, Check, Loader2 } from "lucide-react";

export default function Missions() {
  const { user, refresh } = useAuth();
  const [missions, setMissions] = useState([]);
  const [claiming, setClaiming] = useState(null);
  const [msg, setMsg] = useState("");

  const load = () => api.get("/missions").then(r => setMissions(r.data));
  useEffect(() => { load(); }, []);

  const claim = async (m) => {
    setClaiming(m.id); setMsg("");
    try {
      const { data } = await api.post(`/missions/${m.id}/claim`);
      setMsg(`+${data.reward_amount} ${data.reward_currency} added!`);
      refresh(); load();
      setTimeout(()=>setMsg(""), 2500);
    } catch (e) { setMsg(formatErr(e)); }
    finally { setClaiming(null); }
  };

  return (
    <div className="px-4 py-6">
      <div className="flex items-center gap-2 mb-1">
        <Target className="w-7 h-7 text-[#00E5FF]"/>
        <h1 className="font-outfit font-extrabold text-3xl tracking-tighter">Mission Hifireels</h1>
      </div>
      <p className="text-white/60 text-sm mb-5">Complete missions, earn rewards</p>

      {msg && <div className="mb-4 p-3 rounded-2xl bg-emerald-500/10 border border-emerald-500/30 text-emerald-300 text-sm" data-testid="mission-msg">{msg}</div>}

      <div className="space-y-2.5" data-testid="missions-list">
        {missions.map(m => {
          const pct = Math.min(100, Math.round((m.current / m.target) * 100));
          return (
            <div key={m.id} className={`p-4 rounded-3xl border ${m.completed && !m.claimed ? "bg-gradient-to-br from-[#FF7A00]/15 to-[#FF2A5F]/10 border-[#FF7A00]/40 neon-gold" : "bg-white/5 border-white/10"}`} data-testid={`mission-${m.id}`}>
              <div className="flex items-start gap-3">
                <div className="text-3xl">{m.icon}</div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <h3 className="font-outfit font-bold">{m.title}</h3>
                    {m.claimed && <Check className="w-4 h-4 text-emerald-400"/>}
                  </div>
                  <p className="text-xs text-white/60">{m.description}</p>
                  <div className="mt-2 flex items-center gap-2 text-xs">
                    <div className="flex-1 h-1.5 bg-white/10 rounded-full overflow-hidden">
                      <div className={`h-full rounded-full ${m.completed?"bg-emerald-400":"bg-[#00E5FF]"}`} style={{width: `${pct}%`}}/>
                    </div>
                    <span className="text-white/70">{m.current}/{m.target}</span>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between mt-3 pt-3 border-t border-white/10">
                <div className="flex items-center gap-1 text-xs">
                  <span className="text-white/60">Reward:</span>
                  {m.reward_currency === "goldly" ? (
                    <span className="flex items-center gap-1 text-[#FF7A00] font-bold"><Coins className="w-3.5 h-3.5"/>{m.reward_amount}</span>
                  ) : (
                    <span className="flex items-center gap-1 text-[#FF2A5F] font-bold"><Diamond className="w-3.5 h-3.5"/>{m.reward_amount}</span>
                  )}
                </div>
                {m.claimed ? (
                  <span className="px-3 py-1 rounded-full bg-emerald-500/15 text-emerald-400 text-[10px] font-bold uppercase">Claimed</span>
                ) : m.completed ? (
                  <button onClick={()=>claim(m)} disabled={claiming===m.id} data-testid={`claim-${m.id}`}
                    className="px-4 py-1.5 rounded-full bg-[#FF7A00] text-black text-xs font-bold active:scale-95 disabled:opacity-50 flex items-center gap-1">
                    {claiming===m.id ? <Loader2 className="w-3 h-3 animate-spin"/> : <><GiftIcon className="w-3 h-3"/>Claim</>}
                  </button>
                ) : (
                  <span className="text-[10px] text-white/40 uppercase">In Progress</span>
                )}
              </div>
            </div>
          );
        })}
        {missions.length === 0 && <p className="text-center text-white/40 py-8">No active missions</p>}
      </div>
    </div>
  );
}
